import { Alert } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";

interface GlobalSnackNotifyProps {
  message: string;
  open: boolean;
  onClose: () => void;
  severity: "success" | "error" | "info";
  style?: any;
}

export const GlobalSnackNotify: React.FC<GlobalSnackNotifyProps> = ({
  message,
  open,
  onClose,
  severity,
  style,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      message={message}
      style={style}
    >
      <Alert
        severity={severity}
        variant="filled"
        sx={{
          width: "100%",
          backgroundColor: "#2A3F4D !important",
          fontFamily: "karla, sans-serif !important",
          color: "#FFFFFF !important",
          borderLeft:
            severity === "success"
              ? "12px solid #6EDCA5 !important"
              : severity === "error"
              ? "12px solid #FF9A9A !important"
              : severity === "info"
              ? "12px solid #97B5FF !important"
              : "none",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
